const pre = 'alarm-';

export default [
  {
    path: '/alarm/alarmInfo',
    name: `${pre}alarmInfo`,
    meta: {
      title: '告警中心',
      auth: ['alarm']
    },
    component: () =>
      import ('@/views/alarm/alarmInfo')
  },
  {
    path: '/alarm/mulAlarmInfo',
    name: `${pre}mulAlarmInfo`,
    meta: {
      title: '告警中心',
      auth: ['alarm']
    },
    component: () =>
      import ('@/views/alarm/mulAlarmInfo')
  }
]
